import React from 'react';
import { Box } from '@chakra-ui/react';
import { usePostContext } from '../PostContext';
import SidebarSearch from './SidebarSearch';
import SidebarFeatured from './SidebarFeatured';
import SidebarCategories from './SidebarCategories';
import SidebarTags from './SidebarTags';
import { IPostSidebarProps } from './interfaces';

const PostSidebar: React.FC<IPostSidebarProps> = ({
  featuredPosts,
  categories,
  tags,
}) => {
  const { post } = usePostContext();
  return (
    <Box w={['100%', null, '33.3%']} px="15px">
      <Box mt={6}>
        <SidebarSearch />
        <SidebarFeatured posts={featuredPosts} />
        <SidebarCategories
          categories={categories}
          currentSlug={post?.category?.slug?.current ?? undefined}
        />
        <SidebarTags tags={tags} />
      </Box>
    </Box>
  );
};

export default PostSidebar;
